import React from 'react';
import styled from 'styled-components';
import { Icon } from '@tviklax/ui-components';
import { RiskSignal } from './types';

const Card = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: ${props => props.theme.shadows.md};
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
`;

const Title = styled.h3`
  font-size: 1rem;
  font-weight: 700;
  color: ${props => props.theme.colors.gray800};
`;

const SignalList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const SignalItem = styled.div<{ $status: 'alert' | 'warning' }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  background-color: #f8fafc;
  border: 1px solid ${props => props.$status === 'alert' ? '#fee2e2' : '#fef3c7'};
`;

const SignalText = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
  color: ${props => props.theme.colors.gray800};
`;

interface RiskSignalsProps {
  signals: RiskSignal[];
}

export const RiskSignals: React.FC<RiskSignalsProps> = ({ signals }) => {
  return (
    <Card>
      <Header>
        <Icon name="AlertCircle" color="#64748b" size={20} />
        <Title>Exceptions & Risk Panel</Title>
      </Header>
      <SignalList>
        {signals.map((signal, index) => (
          <SignalItem key={index} $status={signal.status}>
            <Icon
              name={signal.status === 'alert' ? 'AlertCircle' : 'Clock'}
              color="#64748b"
              size={18}
            />
            <SignalText>{signal.label}</SignalText>
          </SignalItem>
        ))}
        {signals.length === 0 && (
          <div style={{ textAlign: 'center', padding: '12px', color: '#64748b', fontSize: '0.875rem' }}>
            No risks detected today.
          </div>
        )}
      </SignalList>
    </Card>
  );
};
